import { t } from "utils/i18n";
import { OrderChannel } from "models";
import { TrackingContentName } from "./tracking";

const EXTERNAL_ORDER_CHANNELS = [
  { label: t("Telephone"), value: OrderChannel.PHONE },
  { label: t("Zalo"), value: OrderChannel.ZALO },
  { label: t("Email"), value: OrderChannel.EMAIL },
  { label: t("Facebook"), value: OrderChannel.FACEBOOK },
  { label: t("Hotline"), value: OrderChannel.HOTLINE },
  { label: t("Teko web/app"), value: OrderChannel.TEKO_WEB_APP },
  { label: t("Teko call"), value: OrderChannel.TEKO_CALL },
];

const EXTERNAL_ORDER_CHANNEL_MAP = {
  [OrderChannel.PHONE]: t("Telephone"),
  [OrderChannel.ZALO]: t("Zalo"),
  [OrderChannel.EMAIL]: t("Email"),
  [OrderChannel.FACEBOOK]: t("Facebook"),
  [OrderChannel.HOTLINE]: t("Hotline"),
  [OrderChannel.TEKO_WEB_APP]: t("Teko web/app"),
  [OrderChannel.TEKO_CALL]: t("Teko call"),
};

const EXTERNAL_ORDER_CHANNELS_WITH_ALL = [{ label: t("All"), value: OrderChannel.ALL }, ...EXTERNAL_ORDER_CHANNELS];

const EXTERNAL_ORDER_FILTER_FORM_TRACKING_MAP = {
  orderChannels: TrackingContentName.OrderChannelSelect,
  siteIds: TrackingContentName.SiteSelect,
  issueDateRange: TrackingContentName.IssueDateRangeSelect,
  entryDateRange: TrackingContentName.EntryDateRangeSelect,
  transactionCode: TrackingContentName.TransactionCodeInput,
};

export default {
  EXTERNAL_ORDER_CHANNELS,
  EXTERNAL_ORDER_CHANNELS_WITH_ALL,
  EXTERNAL_ORDER_CHANNEL_MAP,
  EXTERNAL_ORDER_FILTER_FORM_TRACKING_MAP,
};
